module.exports = __webpack_public_path__ + "static/img/oca2.f4dc5e2b.svg";